import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const UserGroupContext = createContext()

const UserGroupProvider = ({ children }) => {

    const { headers, toast } = useAuth();

    //Get All User Groups
    const getAllUserGroups = async (filter) => {
        const { limit, totalRenderedRecords, filter: filterUserGroup } = filter

        try {
            let { data } = await axios.get(`${baseURL}/user-group/list?limit=${limit ? limit : null}&totalRenderedRecords=${totalRenderedRecords >= 0 ? totalRenderedRecords : null}&filter=${filterUserGroup !== '' ? filterUserGroup : null}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'User Group', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    //Get Single User Groups
    const getSingleUserGroups = async (id) => {
        try {
            let { data } = await axios.get(`${baseURL}/user-group/single-user-group/${id}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'User Group', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    //add User Group
    const createUserGroup = async (userGroupDetail) => {
        try {
            const { data } = await axios.post(`${baseURL}/user-group/create`, userGroupDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'User Group', detail: data.message, life: 3000 })
                }, 500);
                return data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'User Group', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'User Group', detail: "Please fill all fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'User Group', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'User Group', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    //Update User Group
    const updateUserGroup = async (id, userGroupDetail) => {
        try {
            const { data } = await axios.put(`${baseURL}/user-group/update/${id}`, userGroupDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'User Group', detail: data.message, life: 3000 })
                }, 500);
                return data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'User Group', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'User Group', detail: "Please fill all fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'User Group', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'User Group', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    //delete user
    const deleteUserGroup = async (id) => {
        try {
            const { data } = await axios.delete(`${baseURL}/user-group/delete/${id}`, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'User Group', detail: data.message, life: 3000 })
                }, 500);
                return data
            } else {
                toast.current?.show({ severity: 'error', summary: 'User Group', detail: data.message, life: 3000 })
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'User Group', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    return (
        <UserGroupContext.Provider value={{ getAllUserGroups, createUserGroup, updateUserGroup, getSingleUserGroups, deleteUserGroup }}>
            {children}
        </UserGroupContext.Provider>
    )
}

const useUserGroup = () => useContext(UserGroupContext)

export { useUserGroup, UserGroupProvider }